import { render, staticRenderFns } from "./AddNotePanel.vue?vue&type=template&id=a89dffd8&"
import script from "./AddNotePanel.vue?vue&type=script&lang=js&"
export * from "./AddNotePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports